(() => {
  'use strict';
  if (customElements.get('zcat-catalog')) return;
  const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const commonTags = ["aquatic","barbarian","bard","cleric","commoner","dragonborn","druid","dwarf","elf","female","fighter","flying","gnome","halfling","human","monk","noble","orc","paladin","ranger","rogue","sorcerer","tiefling","warlock","wizard"];
  const relatedGroups = [
  [
    "caster",
    "mage",
    "shaman",
    "sorcerer",
    "warlock",
    "wizard"
  ],
  [
    "cleric",
    "fighter",
    "knight",
    "martial",
    "paladin"
  ],
  [
    "gnome",
    "halfling"
  ],
  [
    "lizardfolk",
    "lizardman",
    "troglodyte"
  ],
  [
    "bugbear",
    "goblin",
    "goblinoid",
    "half-orc",
    "hobgoblin",
    "orc"
  ],
  [
    "ghoul",
    "skeleton",
    "undead",
    "walking dead",
    "wight",
    "zombie"
  ],
  [
    "aquatic elf",
    "astral elf",
    "dark elf",
    "drow",
    "eladrin",
    "elf",
    "half-elf",
    "high elf",
    "moon elf",
    "sea elf",
    "shadar-kai",
    "sun elf",
    "wild elf",
    "wood elf"
  ],
  [
    "duergar",
    "dwarf",
    "gray dwarf"
  ],
  [
    "deep gnome",
    "gnome",
    "svirfneblin"
  ],
  [
    "ghost",
    "phantom",
    "shade",
    "specter",
    "spirit",
    "wraith"
  ],
  [
    "archer",
    "bowman",
    "crossbow",
    "ranger",
    "sharpshooter"
  ],
  [
    "assassin",
    "bandit",
    "rogue",
    "thief"
  ],
  [
    "barbarian",
    "berserker",
    "brute"
  ],
  [
    "cleric",
    "cultist",
    "druid",
    "priest",
    "shaman"
  ],
  [
    "king",
    "nobility",
    "noble",
    "queen",
    "royalty"
  ],
  [
    "guard",
    "knight",
    "soldier",
    "warrior"
  ],
  [
    "aquatic",
    "marine",
    "merfolk",
    "underwater"
  ],
  [
    "arachnid",
    "scorpion",
    "spider"
  ],
  [
    "dragon",
    "drake",
    "wyvern"
  ],
  [
    "ooze",
    "slime"
  ],
  [
    "aquatic elf",
    "fishman",
    "koa-toa",
    "kua-toa",
    "kuo-toa",
    "lcathah",
    "locathah",
    "merfolk",
    "merrow",
    "sahuagin",
    "sea elf",
    "triton"
  ],
  [
    "half-elf",
    "half-orc",
    "human"
  ]
];
  const relatedMatch = (record, term) => relatedGroups.some(group => group.includes(term) && group.some(other => other !== term && [...record.tags,...(record.aliases||[])].some(tag => normalize(tag).trim() === other)));
  const typeTags = ['aberration','beast','celestial','construct','dragon','elemental','fey','fiend','giant','humanoid','monstrosity','ooze','plant','undead'];
  const phrases = [...new Set(relatedGroups.flat().filter(t=>t.includes(' ')))].sort((a,b)=>b.length-a.length);
  const searchTerms = value => {
    const words=normalize(value).trim().split(/[\s,;&]+/).filter(t=>t&&t!=='and'&&t!=='or'),terms=[];
    for(let i=0;i<words.length;) {const p=phrases.find(p=>p.split(' ').every((w,j)=>words[i+j]===w));terms.push(p||words[i]);i+=p?p.split(' ').length:1;}
    return [...new Set(terms)];
  };
  const element=(tag,cls,text)=>{const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el;};

  const important=(el,properties)=>Object.entries(properties).forEach(([key,value])=>el.style.setProperty(key,value,'important'));
  const paintChip=button=>{
    const on=button.getAttribute('aria-pressed')==='true';
    important(button,{
      appearance:'none',display:'inline-flex','align-items':'center','justify-content':'center',
      flex:'0 0 auto',width:'auto','min-width':'0','max-width':'100%',height:'auto','min-height':'32px',
      margin:'0',padding:'4px 9px',border:'1px solid '+(on?'#295a42':'#a6b9ac'),
      'border-radius':'5px',background:on?'#295a42':'#ffffff',color:on?'#ffffff':'#294636',
      '-webkit-text-fill-color':on?'#ffffff':'#294636',opacity:'1',visibility:'visible',
      'box-shadow':'none',font:'400 13px/20px system-ui, sans-serif','letter-spacing':'normal',
      'text-transform':'none','text-decoration':'none','white-space':'normal',cursor:'pointer',
      'background-image':'none',transition:'none'
    });
  };
  class ArtCatalog extends HTMLElement {
    connectedCallback() {
      this.outsideEvents?.abort();this.outsideEvents=new AbortController();
      for(const name of ['pointerdown','focusin']) document.addEventListener(name,e=>{if(!this.querySelector('[data-discovery]')?.contains(e.target))this.setPanel(false);},{signal:this.outsideEvents.signal});
      if(this.initialized)return;this.initialized=true;
      for(const key of ['search','sort','list','status','retry','panel'])this[key]=this.querySelector('[data-'+key+']');
      this.dialog=this.querySelector('dialog');
      this.querySelector('.zc-help').textContent='Choose any packs, sizes, or tags. Matches to all choices appear first, then matches to any choice or related tag.';
      this.querySelector('[data-options="common"]').previousElementSibling.textContent = 'Common';
      this.querySelector('[data-options="size"]').previousElementSibling.textContent = 'Sizes';
      this.filters = {pack:new Set(),size:new Set(),tags:new Set()};this.rowCache=new Map();
      this.search.addEventListener('input',()=>this.render());
      for(const name of ['focus','click'])this.search.addEventListener(name,()=>this.setPanel(true));
      this.sort.addEventListener('click',()=>this.setPanel(this.panel.hidden));
      this.querySelector('[data-done]').addEventListener('click',()=>{this.sort.focus();this.setPanel(false);});
      this.querySelector('[data-discovery]').addEventListener('keydown',e=>{
        if(e.key==='Escape'){e.preventDefault();this.sort.focus();this.setPanel(false);}
        if(e.key==='Enter'&&e.target===this.search&&!e.isComposing){e.preventDefault();this.render();this.setPanel(false);}
      });
      this.querySelector('[data-clear]').addEventListener('click',()=>{
        Object.values(this.filters).forEach(set=>set.clear());
        this.panel.querySelectorAll('.zc-chip').forEach(button => button.setAttribute('aria-pressed', 'false'));
        this.search.value='';this.render();
      });
      this.retry.addEventListener('click',()=>this.load());
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();});
      this.dialog.addEventListener('close',()=>this.opener?.focus());this.load();
    }
    disconnectedCallback(){this.outsideEvents?.abort();}
    setPanel(open){if(!this.panel||this.search.disabled)return;this.panel.hidden=!open;for(const el of [this.search,this.sort])el.setAttribute('aria-expanded',String(open));}
    buildFilters(){
      const allTags=[...new Set(['goblinoid', ...this.records.flatMap(r=>r.tags.map(t=>normalize(t).trim()))])].filter(Boolean);
      const reserved=new Set([...commonTags,...typeTags]);
      const groups=[{key:'pack',host:'pack',values:this.records.map(r=>r.pack)},{key:'size',host:'size',values:this.records.map(r=>r.size)},{key:'tags',host:'common',values:commonTags},{key:'tags',host:'type',values:typeTags},{key:'tags',host:'tags',values:allTags.filter(t=>!reserved.has(t))}];
      this.filters.tags=new Set([...this.filters.tags].filter(t=>allTags.includes(t)||reserved.has(t)));
      for(const group of groups){const {key}=group,values=[...new Set(group.values)].filter(Boolean).sort((a,b)=>a.localeCompare(b)),host=this.querySelector('[data-options="'+group.host+'"]');host.replaceChildren();
        if(key!=='tags')this.filters[key]=new Set([...this.filters[key]].filter(v=>values.includes(v)));
        for(const value of values){
          const button = element('button', 'zc-chip', value);
          button.type = 'button';
          button.value = value;
          button.setAttribute('aria-pressed', String(this.filters[key].has(value)));
          button.addEventListener('click', () => {
            if (this.filters[key].has(value)) this.filters[key].delete(value);
            else this.filters[key].add(value);
            button.setAttribute('aria-pressed', String(this.filters[key].has(value)));
            this.render();
          });
            paintChip(button);
            important(host,{display:'flex','flex-wrap':'wrap',gap:'4px','align-content':'flex-start'});
            host.append(button);
        }
      }
    }
    async load(){
      this.retry.hidden=true;this.status.textContent='Loading catalog…';const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
      try{
        const response=await fetch(this.dataset.source,{signal:controller.signal});if(!response.ok)throw Error('Catalog request failed');const data=await response.json();
        if(data.schemaVersion!==1||!Array.isArray(data.records))throw Error('Unsupported catalog format');
        this.packLinks={Underground:'/products/fpm-underground',...data.packLinks};const ids=new Set();
        this.records=data.records.map(r=>{
          if(!Number.isSafeInteger(r.number)||r.number<0||ids.has(r.number)||typeof r.name!=='string'||!r.name||typeof r.size!=='string'||typeof r.pack!=='string'||(r.aliases!==undefined&&(!Array.isArray(r.aliases)||!r.aliases.every(a=>typeof a==='string')))||!Array.isArray(r.tags)||!r.tags.every(t=>typeof t==='string'))throw Error('Invalid record');ids.add(r.number);
          // Derive the family from explicit species tags, never from Orc or a loose name substring.
          if(r.tags.some(t=>['goblin','hobgoblin','bugbear'].includes(normalize(t).trim()))&&!r.tags.some(t=>normalize(t).trim()==='goblinoid'))r={...r,tags:[...r.tags,'goblinoid'].sort()};
          return {...r,searchText:normalize([r.number,String(r.number).padStart(5,'0'),r.name,r.name.replace(/([a-z])([A-Z])/g,'$1 $2'),r.pack,r.size,...r.tags,...(r.aliases||[])].join(' '))};
        });
        this.rowCache.clear();this.buildFilters();this.search.disabled=false;this.sort.disabled=false;this.render();
      }catch(error){this.status.textContent='The catalog could not load. Please try again.';this.retry.hidden=false;console.error('Art catalog:',error);}finally{clearTimeout(timer);}
    }
    imageUrl(r,side){const url=r.images?.[side]?new URL(r.images[side],location.href):new URL(encodeURIComponent(`zcat_${r.number}_${r.name}_${side}.png`),new URL('.',new URL(this.dataset.fileExample,location.href)));if(!['http:','https:'].includes(url.protocol))throw Error('Invalid image URL');return url.href;}
    picture(r,side,large=false){
      const box=element('div',large?'zc-large':'zc-thumb'),img=element('img');
      for(const name of ['contextmenu','dragstart'])box.addEventListener(name,e=>e.preventDefault());
      img.draggable=false;img.alt=r.name+' — '+(side==='A'?'front':'back');img.loading=large?'eager':'lazy';img.decoding='async';
      const missing=()=>box.replaceChildren(element('span','zc-missing',(side==='A'?'Front':'Back')+' image unavailable'));
      img.addEventListener('error',missing,{once:true});box.append(img);try{img.src=this.imageUrl(r,side);}catch{missing();}return box;
    }
    render(){
      if(!this.records)return;
      const selected=Object.entries(this.filters).flatMap(([key,values])=>[...values].map(value=>({key,value:normalize(value).trim()})));
      const terms=searchTerms(this.search.value).filter(term=>!selected.some(c=>c.value===term));
      const count=selected.length+terms.length;
      // Every selected button is a criterion. Nothing excludes candidates before ranking.
      const ranked=this.records.map(record=>{
        let score=0,related=0;
        for(const term of terms){if(record.searchText.includes(term))score++;else if(relatedMatch(record,term))related++;}
        for(const {key,value} of selected){
          const direct=key==='tags'?record.tags.some(t=>normalize(t).trim()===value):normalize(record[key]).trim()===value;
          if(direct)score++;else if(key==='tags'&&relatedMatch(record,value))related++;
        }
        return {record,score,related};
      }).filter(r=>!count||r.score+r.related>0).sort((a,b)=>b.score-a.score||b.related-a.related||a.record.number-b.record.number);
      this.panel.querySelectorAll('.zc-chip').forEach(button=>paintChip(button));
      const full=ranked.filter(r=>r.score===count).length,partial=ranked.length-full;
      this.status.textContent=ranked.length?(partial?`${full} match all terms · ${partial} partial matches`:`${ranked.length} of ${this.records.length} pieces`):'No pieces match. Clear criteria or try another search.';
      const chosen=Object.entries(this.filters).flatMap(([key,values])=>[...values].map(v=>`${key==='tags'?'Tag':key==='pack'?'Pack':'Size'}: ${v}`));this.querySelector('[data-selection]').textContent=chosen.length?chosen.join(' · '):'All pieces';
      const fragment=document.createDocumentFragment();
      ranked.forEach(({record:r},i)=>{
        if(partial&&i===full){const divider=element('div','zc-result-divider');divider.append(element('h3','','Partial matches'),element('p','',full?'These pieces match some of your choices or related tags.':'No pieces match every choice. These match at least one choice or a related tag.'));fragment.append(divider);}
        if(this.rowCache.has(r.number)){fragment.append(this.rowCache.get(r.number));return;}
        const row=element('div','zc-row'),preview=element('button','zc-preview'),details=element('span','zc-details'),headline=element('span','zc-headline'),tags=element('span','zc-meta',r.tags.join(' · '));
        preview.type='button';preview.setAttribute('aria-haspopup','dialog');preview.setAttribute('aria-label',`Preview ${String(r.number).padStart(5,'0')} ${r.name}, front and back`);
        headline.append(element('span','zc-name',r.name),element('span','zc-size',r.size));tags.title=r.tags.join(' · ');details.append(headline,tags);
        preview.append(this.picture(r,'A'),element('span','zc-number',String(r.number).padStart(5,'0')),details);preview.addEventListener('click',()=>this.preview(r,preview));
        let pack=element('span','zc-pack',r.pack);const destination=this.packLinks[r.pack];if(typeof destination==='string'&&/^\/(?!\/)/.test(destination)){pack=element('a','zc-pack',r.pack);pack.href=destination;pack.setAttribute('aria-label','Shop '+r.pack);}
        row.append(preview,pack);this.rowCache.set(r.number,row);fragment.append(row);
      });this.list.replaceChildren(fragment);
    }
    preview(r,opener){this.opener=opener;this.querySelector('[data-detail-number]').textContent='Catalog '+String(r.number).padStart(5,'0');this.querySelector('[data-detail-name]').textContent=r.name;this.querySelector('[data-detail-meta]').textContent=r.pack+' · '+r.size;this.querySelector('[data-detail-tags]').textContent=r.tags.join(' · ');const sides=this.querySelector('[data-sides]');sides.replaceChildren();for(const side of ['A','B']){const figure=element('figure');figure.append(element('figcaption','',side==='A'?'A · Front':'B · Back'),this.picture(r,side,true));sides.append(figure);}const cardFigure=element('figure','zc-card-preview');
      cardFigure.append(element('figcaption','','Future game card'));
      const card=element('div','zc-card-placeholder');
      card.append(element('span','zc-card-badge','Design placeholder'),element('strong','zc-card-title',r.displayName||r.name.replace(/([a-z])([A-Z])/g,'$1 $2')),element('div','zc-card-message','Card not complete'),element('span','zc-card-foot','Catalog '+String(r.number).padStart(5,'0')+' · '+r.pack));
      cardFigure.append(card,element('p','zc-card-note','Future card preview. Miniature artwork is shown separately.'));
      sides.classList.add('zc-with-card');sides.append(cardFigure);
      this.dialog.showModal();}
  }
  customElements.define('zcat-catalog',ArtCatalog);
})();
